import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { useApi } from "../../../shared/api/index";

export const useFetchStatisticForPersonInSeason = (params = {}) => {
  const { fetchData } = useApi();
  const { organizationId, sport, seasonId } = useParams();
  let URL = `${sport}/o/${organizationId}/statistics/for/person/in/seasons/${seasonId}`;
  if (!isEmpty(params)) {
    URL += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["statistic", "person", organizationId],
    queryFn: async () => {
      return await fetchData({
        url: URL,
      });
    },
  });
};

export const useFetchStatisticForTeamInSeason = (params = {}) => {
  const { fetchData } = useApi();
  const { organizationId, sport, seasonId } = useParams();
  let URL = `${sport}/o/${organizationId}/statistics/for/entity/in/seasons/${seasonId}`;
  if (!isEmpty(params)) {
    URL += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["statistic", "team", organizationId],
    queryFn: async () => {
      return await fetchData({
        url: URL,
      });
    },
  });
};
